// extracted by mini-css-extract-plugin
module.exports = {"plate":"TenderRestore__plate___2q6kA","plate__text":"TenderRestore__plate__text___2OI28","plate__button":"TenderRestore__plate__button___3z7s1"};